export const en = {
    "add": "Add",
    "badge-alice-choice": "Alice choice",
    "badge-helpful": "Helpful",
    "badge-interesting": "Interesting",
    "badge-kids": "For kids",
    "badge-new": "New",
    "badge-puzzle": "Puzzle",
    "badge-quest": "Quest",
    "badge-sport": "Sport",
    "badge-tasty": "Tasty",
    "badge-wonderful": "Wonderful",
    "badges": "Badges",
    "description": "Description",
    "headline": "Editor fields",
    "save": "Save",
    "saved": "Saved",
    "tags": " Tags",
    "title": "Title"
} as const;
export const ru = {
    "add": "Добавить",
    "badge-alice-choice": "Выбор Алисы",
    "badge-helpful": "Помощь",
    "badge-interesting": "Огонь",
    "badge-kids": "Для детей",
    "badge-new": "Новое",
    "badge-puzzle": "Заряд ума",
    "badge-quest": "Квест",
    "badge-sport": "Спорт",
    "badge-tasty": "Вкусно",
    "badge-wonderful": "Чудо",
    "badges": "Бейджи",
    "description": "Описание",
    "headline": "Редакторские поля",
    "save": "Сохранить ",
    "saved": "Сохранено",
    "tags": "Тэги",
    "title": "Название"
} as const;